"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerBody = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const mobileWidth = '992px';
exports.ContainerBody = (0, styled_components_1.default)(antd_1.Row) `
  padding: 0 5% 2% 5%;
  margin-top: 117px;
  height: auto;
  position: relative;
  @media screen and (max-width: 1600px) {
    padding: 0 2%;
  }
  @media (max-width: ${mobileWidth}) {
    margin-top: 77px;
  }
`;
